import React from 'react';

import { useTranslation } from 'react-i18next';

import styles from './TextInput.module.css';

interface TimeInputProps {
  name?: string;
  value?: string;
  placeholder?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  label?: string;
  labelTooltip?: React.ReactNode;
  disabled?: boolean;
  required?: boolean;
  [key: string]: TypeAny;
}

export function TimeInput({
  name,
  value,
  onChange,
  placeholder = '',
  required = false,
  labelTooltip,
  error,
  label,
  disabled,
  ...props
}: TimeInputProps) {
  const { t } = useTranslation();
  return (
    <div className={styles.textInputWrap}>
      {label && (
        <span className={styles.textInputLabel}>
          {label}
          {required && ' *'}
          {labelTooltip}
        </span>
      )}
      <input
        type="time"
        value={value}
        required={required}
        placeholder={placeholder || t('placeholder.data')}
        name={name}
        onChange={onChange}
        disabled={disabled}
        className={styles.textInput}
        {...props}
      />
      <p className={styles.textInputError}>{error}</p>
    </div>
  );
}
